import { documentTypes } from "../types/documentTypes";
// import { userPermissionTypes } from "../types/userPermissionTypes";
const initialState = {
    documentData: [],
    documentTypeData: [],
    loading: false
};

export const documentReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case documentTypes.DOCUMENT_LOADING:
      return {
        ...state,
        loading: payload
      };
    case documentTypes.DOCUMENT_DATA:
      return {
        ...state,
        documentData: payload,
        loading: false
      };
      case documentTypes.DOCUMENT_SEARCH_PAYLOAD:
      return {
        ...state,
        searchPayload: payload
      };
      
      case documentTypes.DOCUMENT_AUDIT_DATA:
      return {
        ...state,
        documentData: payload,
        loading: false
      };
      case documentTypes.DOCUMENT_TYPE_DATA:
      return {
        ...state,
        documentTypeData: payload
      };
      
    default:
      return state;
  }
}